import { Clickable, Col, Divider, Icon, Row, Switch, Text } from 'components';
import { theme } from 'lib';

const SettingItem = ({
  name,
  icon,
  reference,
  index,
  dimensions,
  subtitle,
  hasArrow,
  hasSwitch,
  switchActivated,
  onClick,
  scrollRef,
  setSelected,
  isMobile
}) => {
  function handleClick() {
    if (isMobile) return setSelected(index);

    scrollRef.current.scrollTo({
      behavior: 'smooth',
      top: reference.current.offsetTop - 73
    });
  }

  if (name === 'Divider')
    return (
      <Row marg="16px 0 16px 48px">
        <Divider />
      </Row>
    );

  return (
    <Clickable onClick={onClick || handleClick}>
      <Row between center wid="calc(100% - 32px)" pad="12px 16px">
        <Row centerAll>
          <Col centerAll center noFlex ht="24px" wid="24px">
            <Icon type={icon} col={theme.GREY_60} dimensions={dimensions || 20} />
          </Col>

          <Col marg="0 0 0 8px" noFlex center>
            <Text b1 med>
              {name}
            </Text>

            {subtitle && <Text b2>{subtitle}</Text>}
          </Col>
        </Row>

        {hasSwitch && <Switch activated={switchActivated} />}

        {hasArrow && <Icon type="rightChevron" col={theme.GREY_60} dimensions={8} />}
      </Row>
    </Clickable>
  );
};

export default SettingItem;
